import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/page/breadCrumbs_back.png'


const _withScopeId = n => (_pushScopeId("data-v-cd26eb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bread-crumb-unuse"
}
const _hoisted_2 = {
  key: 1,
  class: "bread-crumb-use"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createBlock(_component_a_breadcrumb, { class: "bread-crumb df" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentList, (item, index) => {
        return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
          key: item.path,
          onClick: ($event: any) => (_ctx.backToPage(item))
        }, {
          default: _withCtx(() => [
            (item.isMenu || index + 1 === _ctx.currentList.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.name), 1)),
            (_ctx.showBackIcon + 1 == index && _ctx.showBackIcon !== -1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  src: _imports_0,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.backToPre()), ["stop"])),
                  class: "bread-crumbs-back"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}